/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View } from '@components/atoms'
import { Footer } from '@components/systems'
import { MonolithAccountNav } from '@components/systems/monolith/MonolithAccountNav'
import { customerAccountStyle } from './customerAccount.style'

/**
 * Performance — 인플루언서 계정 페이지 (judahsWeb/PARTNER_PLAN.md §7).
 *
 * 2026-09-26 자리만 잡았다: 계정 네비 + 빈 상태 한 줄. 쿠폰 사용량·정산 예정액은
 * `COUPON.CUSTOMER_ID` 와 `GET /coupon/mine` 이 생긴 뒤 붙는다.
 * 접근은 CustomerLoginGuard 가 역할(INFLUENCER)로 막는다.
 */
const MonolithCustomerPerformancePage = () => {
	return (
		<View css={style}>
			<View className="mnWrap">
				<MonolithAccountNav />

				<View className="mnAccountBody">
					<p className="mnAccountQuiet">No coupon is assigned to this account.</p>
				</View>
			</View>

			<Footer />
		</View>
	)
}

export default MonolithCustomerPerformancePage

const style = css(customerAccountStyle)
